<template lang="pug">
    div
        div.uploadWrapper

            div
                // Upload component
                upload-button.ml-0(
                    ext="'video/mpeg,video/mp4,video/quicktime, video/mov, video/mpeg'"
                    :selectedCallback="select"
                    :isLoading="isLoading"
                ) upload video

            // Progress circle
            div(v-if="file")
                v-progress-circular(
                    :rotate="360"
                    :size="50"
                    :width="5"
                    :value="progress"
                    color="teal"
                )  {{ progress }}

        // File Name
        div.mb-2.fileName(v-if="file || videoFileName")
            span File name: {{ videoFileName }}
</template>

<script>
    import sessions from '~api/sessions';
    import UploadButton from '../UploadButton';
    import VueTypes from 'vue-types';
    import { mapActions } from 'vuex';

    export default {
        props: {
            uploadVideoCallback: VueTypes.func.def(() => {}),
            videoName: VueTypes.string.def('')
        },
        watch: {
            chunks(n, o) {
                if (n.length > 0) {
                    this.upload();
                }

                if (
                    this.uploaded === this.chunksCount &&
                    this.uploaded === this.multipart.Parts.length
                ) {
                    this.finalizeUploadVideo();
                }
            }
        },
        components: {
            UploadButton
        },
        data() {
            return {
                file: null,
                fileName: '',
                isLoading: false,
                chunks: [],
                chunksCount: 0,
                error: null,
                uploaded: 0,
                streamId: null,
                multipart: {
                    Parts: []
                }
            };
        },

        computed: {
            videoFileName() {
                if (this.videoName) return this.videoName;
                if (this.file) return this.file.name;
                return '';
            },
            progress() {
                if (this.file && this.chunksCount && this.uploaded) {
                    return Math.floor(
                        ((this.uploaded - 1) * 100) / this.chunksCount
                    );
                }
            }
        },

        methods: {
            ...mapActions('sessions', ['toggleLoading']),

            async select(file) {
                this.file = file;
                this.uploaded = 0;
                this.multipart = {
                    Parts: []
                };
                this.isLoading = true;
                this.toggleLoading();

                const resp = await sessions.startVideoUpload({
                    fileName: this.file.name
                });

                if (resp.ok) {
                    this.streamId = resp.data.UploadId;
                    this.fileName = resp.data.Key;
                    this.createChunks();
                }
            },
            upload() {
                const formData = new FormData();
                const chunk = new File([this.chunks[0]], this.file.name, {
                    type: this.file.type
                });

                this.uploaded = this.uploaded + 1;

                formData.append('video', chunk);
                formData.append('id', this.streamId);
                formData.append('fileName', this.fileName);
                formData.append('partNumber', this.uploaded);

                try {
                    this.uploadChunks(formData);
                } catch (e) {
                    this.uploadChunks(formData);
                }
            },
            async uploadChunks(formData) {
                const resp = await sessions.uploadVideoChunks(formData);

                if (resp.ok) {
                    this.multipart.Parts.push({
                        ETag: resp.data.ETag.slice(1, -1),
                        PartNumber: this.uploaded
                    });

                    this.chunks.shift();
                }

                return resp.ok;
            },
            createChunks() {
                let size = 6291456;
                this.chunksCount = Math.ceil(this.file.size / size);

                for (let i = 0; i < this.chunksCount; i++) {
                    this.chunks.push(
                        this.file.slice(
                            i * size,
                            Math.min(i * size + size, this.file.size),
                            this.file.type
                        )
                    );
                }
            },

            async finalizeUploadVideo() {
                const params = {
                    id: this.streamId,
                    fileName: this.fileName,
                    multipart: this.multipart
                };

                const resp = await sessions.completeVideoUpload(params);

                if (resp.ok) {
                    this.uploaded = this.uploaded + 1;
                    this.isLoading = false;
                    const url = resp.data.Location.replace(/%2F/g, '/');
                    this.uploadVideoCallback({
                        url,
                        videoName: this.file.name
                    });

                    this.toggleLoading();
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .uploadWrapper
        display: flex
        align-items: center

    .fileName
        fontSize: 15px
</style>
